import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import { Observable } from 'rxjs';

import { ProdutoCategoria } from '../models/produto-categoria';
import { ResponseBase } from '../models/response-base';
import { SuspendProductRequest } from '../models/request/suspend-product-request';

@Injectable({
    providedIn: 'root'
})
export class ProdutoService {
    API: string = environment.API + 'Portal/';
    URL: string = environment.GATEWAY + 'product';
    URL_SUSPEND: string= environment.GATEWAY + 'suspendProduct';


    constructor(private http: HttpClient) { }

    getProductsCategory(): Observable<ResponseBase<ProdutoCategoria>> {
        return this.http.get<ResponseBase<ProdutoCategoria>>(`${this.URL}/categorias`,);
    }

    suspendCollaboratorCard(productGuid: string,collaboratorId: number, suspendProductRequest: SuspendProductRequest): Observable<ResponseBase<any>> {
        return this.http.post<ResponseBase<any>>(`${this.URL_SUSPEND}/${productGuid}/collaborator/${collaboratorId}/suspend`, suspendProductRequest);
    }
}
